import TableHeader from "./table-header";
import TableFooter from "./table-footer";
import UserRank from "./user-rank";
import { useSelector, useDispatch } from "react-redux";
import truncateEthAddress from "truncate-eth-address";
import BigNumber from "bignumber.js";
import { useState, useEffect } from "react";
import { fetchLeaderboard } from "../actions";
import { format } from "d3-format";

function Table() {
  const [page, setPage] = useState(1);

  const participants = useSelector((state) => state.leaderboard.positions);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLeaderboard(page));
  }, [dispatch, page]);

  if (!participants) {
    return null;
  }

  function renderTable() {
    return participants.map((participant, index) => {
      let borderClass = "border-transparent";
      if (participant.rank === 1) {
        borderClass = "border-rank-1";
      } else if (participant.rank === 2) {
        borderClass = "border-rank-2";
      } else if (participant.rank === 3) {
        borderClass = "border-rank-3";
      } else if (participant.rank === 4) {
        borderClass = "border-rank-4";
      } else if (participant.rank === 5) {
        borderClass = "border-rank-5";
      }
      return (
        <div
          className={`flex items-center text-primary-text bg-secondary rounded-lg mb-2 border-l-8 ${borderClass}`}
          key={index}
        >
          <div className="w-1/4 py-4">{participant.rank}</div>
          <div className="w-1/4">
            {truncateEthAddress(participant.subaccount.slice(0, -24))}
          </div>
          <div className="w-1/4">
            $
            {format(",")(
              new BigNumber(participant.pnl).dividedBy(1e18).toFixed(0)
            )}
          </div>
          <div className="w-1/4">
            {new BigNumber(participant.percent_pnl).dividedBy(1e16).toFixed(2)}%
          </div>
        </div>
      );
    });
  }

  return (
    <div className="mt-32 lg:w-5/6 mx-auto sm:w-full">
      <TableHeader />
      <div className="mt-10">
        <div className="flex font-bold text-secondary-text mb-4 ml-2 text-center">
          <div className="w-1/4">Rank</div>
          <div className="w-1/4">Wallet</div>
          <div className="w-1/4">PnL $</div>
          <div className="w-1/4">PnL %</div>
        </div>
        <div className="text-center">
          <UserRank />
          {renderTable()}
        </div>
        <TableFooter page={page} setPage={setPage} />
      </div>
    </div>
  );
}

export default Table;
